require.register("modules/m0x/a02/page-15-he/page-15-he", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_15_he = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_15_he;

  
});

